export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_02.66389dec.jpg";